module.exports = __webpack_public_path__ + "static/media/7omagames.bd2f318d.jpg";